import { render, staticRenderFns } from "./dashboard_version.vue?vue&type=template&id=07fe7d95&scoped=true&"
import script from "./dashboard_version.vue?vue&type=script&lang=js&"
export * from "./dashboard_version.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_version.vue?vue&type=style&index=0&id=07fe7d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe7d95",
  null
  
)

export default component.exports